import Controller from '@ember/controller';
import CustomerModel from 'cio/models/customer';
import { inject as service } from '@ember/service';
import FacebookLeadAdsService from 'cio/services/facebook-lead-ads';
import CustomFormsService from 'cio/services/custom-forms';
import { tracked } from '@glimmer/tracking';

const DEFAULTS = {
  continuation: null,
};

export default class PersonSubjectsIndexController extends Controller {
  @service customForms!: CustomFormsService;
  @service facebookLeadAds!: FacebookLeadAdsService;

  queryParams = ['type', 'continuation'];

  person!: CustomerModel;
  @tracked continuation: null | string = DEFAULTS.continuation;
  @tracked type = 'segment';
  @tracked meta = {};

  filters = [
    {
      name: 'Segment Triggered',
      value: 'segment',
      icon: 'segment',
    },
    {
      name: 'Event Triggered',
      value: 'event',
      icon: 'event',
    },
  ];

  resetPagination() {
    this.continuation = DEFAULTS.continuation;
  }
}
